export * from './profile/profile.component';
